'use client';

import { ContentOutageNotice } from '@/components/ContentOutageNotice';

/**
 * Segment boundary for the Mongo-backed help pages.
 *
 * Without it these fell through to the root `app/error.tsx`, which is written
 * for a signed-in user hitting a bug — wrong copy, and a Contact Support link,
 * for a reader caught by a transient database outage (RELM-350).
 */
export default function HelpError({ reset }: { reset: () => void }) {
  return (
    <ContentOutageNotice
      what="help page"
      indexHref="/help"
      indexLabel="Help centre home"
      reset={reset}
    />
  );
}
